import React from "react";
import Lottie from "react-lottie";
import animationData from "./animations/Preloader.json";

// STYLES
import { Container } from "./PreloaderStyled";

const Preloader = (props: any) => {
  const { width, height } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Container width={width} height={height}>
      <Lottie options={defaultOptions} height={height} width={width} />
    </Container>
  );
};

export default Preloader;
